'use strict';

module.exports = String.prototype.includes;